export const AUTH_TRANSLATION_NAMESPACE = "auth";

export const AUTH_LOGIN_VIEW_TK = "AUTH_LOGIN_VIEW_TK";
export const AUTH_FORGET_VIEW_TK = "AUTH_FORGET_VIEW_TK";
export const AUTH_THANKS_VIEW_TK = "AUTH_THANKS_VIEW_TK";
export const AUTH_REGISTER_VIEW_TK = "AUTH_REGISTER_VIEW_TK";
